<template>
  <div class="myworktwo">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>我的工作
      </span>
      <el-radio-group v-model="Position" style="margin-bottom: 30px;" @change="getdata()">
        <el-radio-button label="4">待办事务</el-radio-button>
        <el-radio-button label="5">完成事务</el-radio-button>
      </el-radio-group>

      <span class="other more" @click="toMore()">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="myworkTemporary-main">
      <el-tabs style="height: 200px;">
        <el-table
          :data="tableData"
          stripe
          :height="240"
          :show-header="false"
          @cell-click="gowork"
          ref="tabs"
          v-loading="loading"
        >
          <el-table-column width="50" class="one"></el-table-column>
          <el-table-column :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.TaskShowName}}</span>
              <span style="color:red">{{scope.row.WariningContext}}</span>
            </template>
          </el-table-column>

          <el-table-column width="100">
            <template slot-scope="scope">{{scope.row.StartTime | formatDate('yyyy-MM-dd')}}</template>
          </el-table-column>
        </el-table>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { mapState } from 'vuex';
import { MyWorkControllerSvr } from '@/service/MyWorkControllerSvr';
export default {
  components: {},
  props: {},
  data() {
    return {
      Position: '4',
      tableData: [],
      loading: true,
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
     this.MyWorkControllerSvr = new MyWorkControllerSvr();
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
          this.loading = true;
          this.MyWorkControllerSvr.getMyTaskList(
            this.token,
            null,
            this.Position,
            null,
            null,
            0,
            6
          ).then(res => {
            this.tableData = res._Items;
            this.loading = false;
          });
        },
    gowork(item) {
      this.$router.push({
        path: JSON.parse(item.ActionPara).Url1,
        query: {
          workId: item.WorkID,
          taskName: item.TaskName,
          bisKey: item.MainParaIn.Value,
          taskStatus: item.TaskStatus
        }
      });
    },
    toMore() {
      this.$router.push({
        path: '/myworkList',
        query: {
          taskStatus: this.Position
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.myworktwo{
  background-color: #fff;
  .index-header {
    position: relative;
    .el-radio-group {
      position: absolute;
      left: 140px;
      // margin-top: 15px;
      margin-bottom: 0 !important;
      .el-radio-button {
        .el-radio-button__inner {
          padding: 6px 20px;
        }
      }
    }
  }
  .myworkTemporary-main {
    text-align: center;
    height: 260px;

    .el-table {
      padding: 2px 0 20px 0px;
      .el-table__body-wrapper {
        .el-table__row {
          td:nth-child(1) {
            margin-left: 10px;
            position: relative;
            &::after {
              position: absolute;
              left: 35px;
              top: 50%;
              margin-top: -3px;
              content: '';
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #0f77f2;
            }
          }
        }
      }
    }
  }
  .el-table {
    .el-table__body-wrapper {
      tr {
        cursor: pointer;
      }
    }
  }
}
</style>
